module.exports = __webpack_public_path__ + "img/auth-left-male.16c18b83.jpg";